// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f90e60d9","147":"2302332c","200":"61467361","235":"fc20a81a","355":"f7a6f1aa","383":"004bafb0","390":"2d91c306","566":"f41f6ecb","583":"bf0326ea","631":"1edd97bb","659":"beca1f4f","745":"dca87cce","872":"00c69242","900":"e83b7468","936":"34c7fb41"}[chunkId] + ".chunk.js";
};